// UploadDocumentsButton - file the project's documents from the overview
// and the technical documentation: PDFs, DWGs, models, Excel, schedules,
// Word, ZIP (Document Control's own upload, helpers/docTypes). This is how
// the documentation gets what it is built from; the manifest itself is
// never hand-published from the page.
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "antd";
import { CloudUploadOutlined } from "@ant-design/icons";
import UploadDocumentModal from "components/DocumentControl/UploadDocumentModal";
import { getDiscipline } from "api/discipline/getDiscipline";

export default function UploadDocumentsButton({ projectId, projectTitle, onUploaded, size = "small", type }) {
  const company = useSelector((s) => s.user && s.user.userInfo && s.user.userInfo.company);
  const [open, setOpen] = useState(false);
  const [disciplines, setDisciplines] = useState([]);
  const projects = useMemo(() => [{ _id: projectId, title: projectTitle || "This project" }], [projectId, projectTitle]);
  useEffect(() => {
    if (!open || !company || disciplines.length) return;
    Promise.resolve(getDiscipline(company))
      .then((res) => setDisciplines(Array.isArray(res) ? res : (res && res.data) || []))
      .catch(() => setDisciplines([]));
  }, [open, company, disciplines.length]);
  return (
    <>
      <Button size={size} type={type} icon={<CloudUploadOutlined />} onClick={() => setOpen(true)}
              title="PDF, DWG/DXF, Revit/IFC/Navisworks models, Excel/CSV, P6/MS Project, Word and ZIP">
        Upload documents
      </Button>
      <UploadDocumentModal open={open} onClose={() => setOpen(false)} projectId={projectId}
                           projects={projects} disciplines={disciplines}
                           onUploaded={(doc) => { if (onUploaded) onUploaded(doc); }} />
    </>
  );
}
